import { render, staticRenderFns } from "./JcdcLoginTemplate.vue?vue&type=template&id=0725696e"
import script from "./JcdcLoginTemplate.vue?vue&type=script&lang=ts"
export * from "./JcdcLoginTemplate.vue?vue&type=script&lang=ts"
import style0 from "./JcdcLoginTemplate.vue?vue&type=style&index=0&id=0725696e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports